var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/deadline-notice-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-59e4aab4!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/deadline-notice-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DeadlineNotice.vue
// module id = 598
// module chunks = 1